import { render, staticRenderFns } from "./jitsiMeet.vue?vue&type=template&id=4029a152&scoped=true"
import script from "./jitsiMeet.vue?vue&type=script&lang=js"
export * from "./jitsiMeet.vue?vue&type=script&lang=js"
import style0 from "./jitsiMeet.vue?vue&type=style&index=0&id=4029a152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4029a152",
  null
  
)

export default component.exports